import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../core/services/loading/loading';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Profile } from '../../../core/models/users.interface';
import { dualListSettings } from '../../../../main';
import { SectorService } from '../../../core/services/sector/sector';
import { Sector } from '../../../core/models/sector.interface';
import { GroupService } from '../../../core/services/group/group';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'app-sector-assing',
  imports: [AngularDualListBoxModule, MatIcon],
  templateUrl: './sector-assing.html',
  styleUrl: './sector-assing.scss',
})
export class SectorAssing {
  sector: Sector[] = [];
  selected: Sector[] = [];
  profile: Profile | null = null;
  format = dualListSettings;
  @Input() filtro: string = '';
  @Input() orden: string = '';
  limit = 10;
  total = 0;
  errorMsg: string[] | null = null;

  constructor(
    private sectorService: SectorService,
    private groupService: GroupService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    private dialogRef: MatDialogRef<SectorAssing>,
    @Inject(MAT_DIALOG_DATA) data: { profile: Profile | null },
  ) {
    this.profile = data.profile;
  }

  ngOnInit(): void {
    this.fetchSectors();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  fetchSectors() {
    this.sectorService.getSectors().subscribe((sectors) => {
      this.sector = [...sectors];

      if (this.profile) {
        this.selected = (this.profile.user_sector ?? []).map((item) => item.sector);
      }

      this.cdr.markForCheck();
    });
  }

  onSubmit() {
    if (!this.profile) return;

    const payload = {
      user: this.profile.id,
      sectors: this.selected.map((sector) => sector.id),
    };

    this.loadingService.show(true);
    this.groupService.assignSector(payload).subscribe({
      next: () => {
        this.loadingService.show(false);
        this.toastr.success('Los sectores fueron actualizados correctamente!', 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loadingService.show(false);
        this.toastr.error(
          'Error: ' + (err.error?.error ?? err.error?.detail ?? err.message),
          undefined,
          {
            progressBar: true,
            timeOut: 5000,
          },
        );
      },
    });
  }
}
